import { isObject, isArray, mergeWith, isPlainObject, uniq } from 'lodash-es';

type CustomValue = Array<unknown> | object | undefined;

function customizer(oldValue: CustomValue, newValue: CustomValue): CustomValue {
  if (isArray(oldValue) && isArray(newValue)) {
    return uniq(oldValue.concat(newValue));
  }

  if (newValue === undefined) {
    return oldValue;
  }

  if (oldValue === undefined) {
    return newValue;
  }

  if (isObject(newValue) && !isArray(newValue)) {
    if (isPlainObject(newValue) && !Object.keys(newValue).length) {
      return newValue;
    }
    return mergeWith(oldValue, newValue, customizer);
  }

  return newValue;
}

export default function (oldObj: object | undefined, newObj: object | undefined): CustomValue {
  return mergeWith(oldObj, newObj, customizer);
}
